<template>
  <div class="wbench-process-main">
    <div class="wbench-form-header">
      <el-button class="send-btn" type="primary" @click="sendEvt">
        <!-- <img :src="sendInfo.btnIcon" class="wbench-btn-image large" /> -->
        <i class="el-icon-s-promotion wbench-btn-image large inline-block"></i>
        <div>发送</div>
      </el-button>
      <div class="right-content">
        <el-input size="small" v-model="matter.businessName" readonly>
          <template slot="prepend">标题</template>
        </el-input>
        <el-form
          :inline="true"
          size="mini"
          :model="formInline"
          class="flow-form-inline form-has-file"
        >
          <el-form-item>
            <el-button size="small" @click="saveEvt" class="right-btn btn-special">
              <img :src="saveInfo.btnIcon" class="wbench-btn-image" />
              <span>保存待发</span>
            </el-button>
          </el-form-item>
          <el-form-item v-if="topShow" label="内部分发" class="form-item-special">
            <el-input
              v-model="formInline.user"
              @click.native="userBox.show = true"
              placeholder="请选择内部分发人员"
              readonly
            ></el-input>
            <!--            <i class="el-icon-circle-close" @click.stop="clearCCuser"></i>-->
          </el-form-item>
          <el-form-item v-if="topShow" label="附件" class="form-item-special last">
            <el-input
              v-model="formInline.attNames"
              readonly
              placeholder="请选择附加附件"
              @click.native="showUploadBox"
            ></el-input>
            <i class="el-icon-circle-close" @click.stop="clearFile"></i>
            <!--多文件附件上传input-->
            <input
              id="secondUploadFile"
              class="upload-file-box"
              type="file"
              multiple
              @change="multiUpload"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="wbench-form-container">
      <div class="left-box">
        <el-tabs type="border-card">
          <el-tab-pane :label="formData.packageType === 1 ? '文单' : '表单'">
            <div class="tab-page-box">
              <div v-if="formData.packageType !== 3" class="child-box">
                <div class="child-page">
                  <szgc-form-getor
                    ref="wbenStartFormComponent"
                    :runTimeFields="runTimeFields"
                    :config="formConfig"
                    status="mine"
                  ></szgc-form-getor>
                </div>
              </div>
              <div v-if="formData.packageType === 3" class="wbench-iframe-box">
                <iframe
                  ref="wbenchIframe"
                  :src="iframeUrl"
                  frameborder="0"
                  @load="bindEvent"
                  class="wbench-iframe-web"
                ></iframe>
              </div>
            </div>
          </el-tab-pane>
          <!--附件-->
          <el-tab-pane v-if="fileShow" label="附件">
            <div class="tab-page-box">
              <UploadFile :config="formConfig" :auth="true"></UploadFile>
            </div>
          </el-tab-pane>
          <!--流程图片-->
          <el-tab-pane label="流程" lazy>
            <div class="tab-page-box">
              <div v-if="flowImg.url" class="wbench-flow-img-box">
                <img :src="flowImg.url" />
              </div>
              <span v-else>暂无图片</span>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="right-box description-box">
        <div v-if="description" v-dompurify-html="description" class="description"></div>
        <div v-if="!description" class="description center">暂无描述</div>
      </div>
    </div>
    <!--抄送人选择-->
    <user-select
      :show.sync="userBox.show"
      @user-checked="copyUserChecked"
      :manager-enable="true"
      :users="userBox.users"
      :multiEnable="true"
    ></user-select>
  </div>
</template>
<script>
import Api from "../../../api/index";
import request from "../../../api/request";
import { getCookie } from "@szgc/plt-core-v2";
import UserSelect from "../../../components/UserSelect/index.vue";
import { SzgcFormGetor } from "@/index";
import { Loading } from "element-ui";
import UploadFile from "../../../components/UploadFile/index.vue";
import { buildVueDompurifyHTMLDirective } from "vue-dompurify-html";
import dompurify from "dompurify";

export default {
  name: "InitForm",
  components: {
    UserSelect,
    SzgcFormGetor,
    UploadFile
  },
  directives: {
    "dompurify-html": buildVueDompurifyHTMLDirective({}, dompurify)
  },
  props: {
    // 表单数据
    formData: {
      type: Object,
      required: true
    },
    // 流程信息
    flowInfo: {
      type: Object,
      required: true
    },
    topShow: {
      type: Boolean,
      default: false
    },
    runTimeFields: {
      type: Object,
      default() {
        return {};
      }
    },
    fileShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      matter: {
        businessName: ""
      },
      flowImg: {
        show: false,
        url: ""
      },
      userBox: {
        //抄送人
        show: false,
        users: [],
        corp: null
      },
      nextUserBox: {
        //执行人
        show: false,
        users: [],
        corp: null
      },
      formInline: {
        user: "",
        userId: "",
        attNames: "",
        attIds: ""
      },
      formConfig: {
        auths: "",
        formRenderData: "",
        results: "",
        businessId: "",
        businessName: "",
        pacId: "",
        reqToken: ""
      },
      sendInfo: {},
      saveInfo: {},
      fileUpdLoading: null,
      businessId: "",
      reqToken: "",
      description: "",
      prefix: "",
      iframeUrl: ""
    };
  },
  created() {
    this.prefix = getCookie("plt-api-route") || "";
    const pageData = JSON.parse(JSON.stringify(this.formData));
    this.formConfig = {
      ...pageData,
      auths: pageData.auths,
      formRenderData: pageData.formRender,
      results: pageData.fields,
      businessId: pageData.businessId,
      businessName: pageData.businessName,
      pacId: pageData.pacId,
      reqToken: pageData.reqToken
    };
    this.matter.businessName = pageData.businessName;
    this.businessId = pageData.businessId;
    this.sendInfo = pageData.send;
    this.saveInfo = pageData.save;
    this.reqToken = pageData.reqToken;
    this.flowImg.url = `${this.prefix}/api/appproc/packages/${pageData.pacId}/flows/${pageData.flowCfgId}/image.png`;
    this.description = pageData.packageDescription;

    if (this.formData.packageType === 3) {
      // this.iframeUrl = window.origin + "/process-workbench-web/#/iframe?businessId=" + this.businessId;  //!!!!todo JSON.parse(this.formData.fields.iframe.value).web
      const path = JSON.parse(this.formData.fields.iframe.value).web;
      const searchParams = new URLSearchParams({
        businessId: this.businessId,
        clientType: "web",
        page: "mine"
      });
      if (path.indexOf("http:") > -1 || path.indexOf("https:") > -1) {
        this.iframeUrl = `${path}?${searchParams}`;
      } else {
        this.iframeUrl = `${window.origin}${path}?${searchParams}`;
      }
    }
  },
  destroyed() {
    window.removeEventListener("message", this.getMessage);
  },
  methods: {
    /*清空抄送人*/
    clearCCuser() {
      this.formInline.user = "";
      this.formInline.userId = "";
    },
    /*清除附件*/
    clearFile() {
      this.formInline.attIds = "";
      this.formInline.attNames = "";
    },
    /*iframe加载完毕*/
    bindEvent() {
      window.addEventListener("message", this.getMessage);
    },
    /*iframe子传父*/
    getMessage(event) {
      const data = event.data;
      if (data && data.data && data.type && data.type === "szgc-wbench-iframe") {
        if (data.page && data.page === "mine") {
          if (data.btnKey === "send") {
            //发送
            this.handleSend(data.data);
          } else {
            //保存待发
            this.handleSave(data.data);
          }
        }
      }
    },
    /*iframe父传子*/
    sendMessage(btnKey) {
      let iframe = this.$refs.wbenchIframe;
      iframe.contentWindow.postMessage(
        {
          businessId: this.businessId,
          page: "mine",
          btnKey: btnKey,
          type: "szgc-wbench-iframe"
        },
        this.iframeUrl
      );
    },
    /*发送*/
    async sendEvt() {
      let formBoxData = {};
      if (this.formData.packageType !== 3) {
        //非iframe
        const allData = await this.$refs.wbenStartFormComponent.getFormValues();
        if (!allData.valid) {
          this.$message.error(allData.message ? allData.message : "操作失败，有必填项未填!");
          return false;
        }
        formBoxData = allData.data;
        this.handleSend(formBoxData);
      } else {
        //iframe
        this.sendMessage("send");
      }
    },
    /*发送接口请求*/
    async handleSend(formBoxData) {
      const { matter, flowInfo, formInline } = this;
      const pacId = flowInfo.pacId;
      const ccs = [];
      if (formInline.userId) {
        const splitCcIds = formInline.userId.split(","),
          splitCcNames = formInline.user.split(",");
        for (let i = 0; i < splitCcIds.length; i++) {
          ccs.push({
            realName: splitCcNames[i],
            userId: splitCcIds[i]
          });
        }
      }
      const params = {
        attIds: this.formInline.attIds === "" ? null : this.formInline.attIds,
        businessId: this.businessId,
        businessName: matter.businessName,
        ccs: ccs.length > 0 ? ccs : null,
        fields: formBoxData,
        flowCfgId: flowInfo.businessId,
        nextCus: null, //现在不需要执行人nextCus了
        pacId: pacId ? pacId : this.formConfig.pacId,
        reqToken: this.reqToken
      };
      try {
        const { success, message } = await request({
          url: this.prefix + Api.sendInitial(),
          method: "post",
          data: params
        });
        if (!success) {
          return this.$message.error("流程发送失败:" + message);
        }
        this.$message.success("流程发送成功");
        this.$emit("childEvt", { btnKey: "send" }, params);
      } catch (error) {
        this.$message.error("流程发送失败");
      }
    },
    /*保存待发事件*/
    async saveEvt() {
      let formBoxData = {};
      if (this.formData.packageType !== 3) {
        //非iframe
        const allData = await this.$refs.wbenStartFormComponent.getFormValues(false);
        formBoxData = allData.data;
        this.handleSave(formBoxData);
      } else {
        this.sendMessage("save");
      }
    },
    /*保存待发接口请求*/
    async handleSave(formBoxData) {
      const { matter, flowInfo, formInline } = this;
      const pacId = flowInfo.pacId;
      const ccs = [];
      if (formInline.userId) {
        const splitCcIds = formInline.userId.split(","),
          splitCcNames = formInline.user.split(",");
        for (let i = 0; i < splitCcIds.length; i++) {
          ccs.push({
            realName: splitCcNames[i],
            userId: splitCcIds[i]
          });
        }
      }
      const params = {
        attIds: this.formInline.attIds === "" ? null : this.formInline.attIds,
        businessId: this.businessId,
        businessName: matter.businessName,
        ccs: ccs.length > 0 ? ccs : null,
        fields: formBoxData,
        flowCfgId: flowInfo.businessId,
        pacId: pacId ? pacId : this.formConfig.pacId,
        reqToken: this.reqToken
      };
      try {
        const { success, message } = await request({
          url: this.prefix + Api.saveInitial(),
          method: "post",
          data: params
        });
        if (!success) {
          return this.$message.error("流程保存待发失败:" + message);
        }
        this.$message.success("流程保存待发成功");
        this.$emit("childEvt", { btnKey: "save" }, params);
      } catch (error) {
        this.$message.error("流程保存待发失败");
      }
    },
    /*抄送人选择*/
    copyUserChecked(data) {
      const { formInline } = this;
      if (data.source.length === 0) {
        formInline.user = "";
        formInline.userId = "";
        this.userBox.users = "";
        return;
      }
      formInline.user = data.text;
      formInline.userId = data.valueText;
      this.userBox.users = formInline.userId.split(",");
    },
    /*附件box点击*/
    showUploadBox() {
      document.getElementById("secondUploadFile").value = "";
      document.getElementById("secondUploadFile").click();
    },
    /*多文件上传*/
    multiUpload(event) {
      let files = event.target.files;
      let formData = new FormData();
      if (files.length === 0) {
        return false;
      }
      for (let i = 0; i < files.length; i++) {
        formData.append("files", files[i]);
      }
      this.fileUpdLoading = Loading.service({
        lock: true,
        fullscreen: true,
        text: "附件上传中..."
      });
      request({
        url: this.prefix + Api.mulUploadFiles,
        method: "post",
        data: formData
      })
        .then((res) => {
          if (res.success) {
            let tempIds = [],
              tempNames = [];
            if (res.data && res.data.length && res.data.length > 0) {
              res.data.map((item) => {
                tempIds.push(item.fileId);
                tempNames.push(item.name);
              });
            }
            this.formInline.attIds = tempIds;
            this.formInline.attNames = tempNames.join(",");
            this.$message.success("附件上传成功");
          } else {
            this.formInline.attIds = "";
            this.formInline.attNames = "";
            this.$message.error("附件上传失败");
          }
          this.fileUpdLoading.close();
        })
        .catch((error) => {
          this.formInline.attIds = "";
          this.formInline.attNames = "";
          this.fileUpdLoading.close();
          this.$message.error("附件上传失败: " + error);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.description-box {
  overflow: auto;
}
</style>

